// Next
import Image from 'next/image';
import { useRouter } from 'next/router';

// Contentful
import { imageLoader } from '../../helpers/contentful';

const ImageBlock = (props) => {
  const { image, caption } = props;

  const router = useRouter();

  return (
    <>
      {image && (
        <div className="ImageBlock">
          <div className="ImageBlock-figure">
            <Image
              className="ImageBlock-image"
              layout="responsive"
              loader={imageLoader}
              lazyBoundary="500px"
              src={`https:${image.fields.file.url}`}
              height={image.fields.file.details.image.height}
              width={image.fields.file.details.image.width}
              alt={image.fields.title}
            />
          </div>
          {typeof window !== 'undefined' && router.query.download === 'pdf' && (
            <img className="ImageBlock-image--pdf" src={image.fields.file.url} alt={image.fields.title} />
          )}

          {caption && (
            <div className="ImageBlock-caption">
              <p>{caption}</p>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default ImageBlock;
